import moment from 'moment-timezone';

class DateHelper {
    static convertTimezone = (inputDate: any) => {
        const utcTimezone = moment.tz(inputDate, 'UTC');
        const amsterdamTimezone = utcTimezone.clone().tz('Europe/Amsterdam');

        return amsterdamTimezone;
    }

    static getFullDate = (inputDate: any) =>
        this.convertTimezone(inputDate)
            .format('D-M-YYYY, HH:mm:ss');

    static getDateFormat = (inputDate: any) =>
        this.convertTimezone(inputDate)
            .format('D-M-YYYY');
}

export default DateHelper;